import Axios from "@/utils/Axios";
import Axios2 from "@/utils/Axios2"
import qs from "qs";

export default {
  /**
   * 获取图表数据
   * @param monitorSiteId 监测点ID
   * @param params 参数
   * @param startTime 开始时间
   * @param endTime 结束时间
   * @returns {Promise}
   */
  getChartData(monitorSiteId, params, startTime, endTime) {
    return Axios.ajax({
      method: "post",
      url: "/analogData/instantParamDataV2",
      data: qs.stringify({
        monitorSiteId: monitorSiteId,
        params: params,
        startTime: startTime,
        endTime: endTime,
      })
    });
  },

  getCalendarDate(monitorSiteId, startTime,endTime){
    return Axios2.ajax({
      method: 'get',
      url: `/api/v1/statistic/monitorDayRiskLevels`,
      params: {
        monitorSiteId: monitorSiteId,
        startTime: startTime,
        endTime: endTime,
      }
    })
  },

  getTimeLineData(monitorSiteId, startDateTime, endDateTime){
    return Axios2.ajax({
      method: 'post',
      url: `/api/v1/statistic/monitorSite/riskDayLine`,
      data:{
        monitorSiteId: monitorSiteId,
        startDateTime: startDateTime,
        endDateTime: endDateTime,
      }
    })
  }
}
